export default [
  {
    path: '/pagos-vencidos',
    name: 'overduePayments',
    component: () => import('@/views/payments/OverduePayments.vue'),
    meta: {
      requiresAuth: true,
    },
  },
]
